var _g;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgResos(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    fill: "none",
    viewBox: "0 0 48 48",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _g || (_g = /*#__PURE__*/React.createElement("g", {
    fill: "currentColor"
  }, /*#__PURE__*/React.createElement("path", {
    d: "m22.66 2.43-.5 3.45c-8.63.6-16.62 5.47-14.93 14.62.17.94.98 1.37 1.9 1.1 9.39-3.6 20-3.67 29.04-.21 1.21.32 2.55-.37 2.72-1.64 1.13-8.62-6.58-13.24-14.93-13.86l-.5-3.46c-.15-.57-2.64-.57-2.8 0Z"
  }), /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    d: "M27.97 43.97c-3.36 2.7-4.58 2.7-7.95 0 0 0-13.93-2.53-9.87-20.42 7.01-3.16 20.71-3.27 27.7 0 4.07 17.34-9.88 20.42-9.88 20.42Zm5.05-7.27c-.56.8-1.55.16-1.33-.8.8-3.47.95-7.39-.47-11.06 1.56.22 2.41.41 3.87 1.02.5 3.39.1 7.7-2.07 10.84Z",
    clipRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgResos);
export default __webpack_public_path__ + "static/media/resos.3ae046b0809989ade304721f0c711ba7.svg";
export { ForwardRef as ReactComponent };